import script from "./VInputSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./VInputSelect.vue?vue&type=script&setup=true&lang=ts"

import "./VInputSelect.vue?vue&type=style&index=0&id=5a7f53ee&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a7f53ee"]])

export default __exports__